// extracted by mini-css-extract-plugin
module.exports = {"banner":"_2ONvs","sparse":"_2vj1S","icon":"_3rVHu","primary":"_15LIn","shopify":"SXm-L","warning":"_3jiBC","error":"_1gbhM","secondary":"OYmAP"};